import { graphql, useStaticQuery } from "gatsby"
import { useLocalization } from "gatsby-theme-i18n"

export default () => {
  const { locale } = useLocalization()

  const data = useStaticQuery(graphql`
    query flyersQuery {
      globals(handle: { eq: "flyers" }) {
        flyers {
          locale
          document {
            url
          }
        }
      }
    }
  `)

  return data.globals?.flyers
}
